import React from 'react';
import { X } from 'lucide-react';
import ContractRenewalSettings from './ContractRenewalSettings';
import {
  modalBackdropStyle,
  modalHeaderStyle,
  modalStyle,
} from './styles';
import {
  stdModalHeaderIconBox, stdModalHeaderTitle, stdModalHeaderSub, stdModalCloseBtn,
} from '../adminlayout/designStandard';

export default function ContractRenewalSettingsModals({
  manualOpen,
  settingsOpen,
  apiBase,
  companyCode,
  companySelector,
  onCloseManual,
  onCloseSettings,
  onChanged,
  setMessage,
}) {
  return (
    <>
      {manualOpen && (
        <div style={modalBackdropStyle} onMouseDown={onCloseManual}>
          <div style={modalStyle} onMouseDown={(event) => event.stopPropagation()}>
            <div style={modalHeaderStyle}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <div style={stdModalHeaderIconBox}>✏️</div>
                <div style={{ minWidth: 0 }}>
                  <h3 style={{ ...stdModalHeaderTitle, margin: 0 }}>직접 등록</h3>
                  <div style={stdModalHeaderSub}>자동등록 대상이 아닌 직원을 계약갱신관리 대상으로 등록합니다.</div>
                </div>
              </div>
              <button type="button" style={stdModalCloseBtn} onClick={onCloseManual}>
                <X size={15} />
              </button>
            </div>
            <div style={{ padding: 16 }}>
              {companySelector}
              <ContractRenewalSettings
                apiBase={apiBase}
                companyCode={companyCode}
                onChanged={async () => {
                  await onChanged?.();
                  onCloseManual();
                }}
                setMessage={setMessage}
                showRules={false}
              />
            </div>
          </div>
        </div>
      )}

      {settingsOpen && (
        <div style={modalBackdropStyle} onMouseDown={onCloseSettings}>
          <div style={modalStyle} onMouseDown={(event) => event.stopPropagation()}>
            <div style={modalHeaderStyle}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <div style={stdModalHeaderIconBox}>⚙️</div>
                <div style={{ minWidth: 0 }}>
                  <h3 style={{ ...stdModalHeaderTitle, margin: 0 }}>계약갱신 설정</h3>
                  <div style={stdModalHeaderSub}>부서별 자동등록 기준을 관리합니다.</div>
                </div>
              </div>
              <button type="button" style={stdModalCloseBtn} onClick={onCloseSettings}>
                <X size={15} />
              </button>
            </div>
            <div style={{ padding: 16 }}>
              {companySelector}
              <ContractRenewalSettings
                apiBase={apiBase}
                companyCode={companyCode}
                onChanged={onChanged}
                setMessage={setMessage}
                showManual={false}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
